import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createSlots as _createSlots, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/39.jpg'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "teaching-book" }
const _hoisted_4 = { class: "teaching-book-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "teaching-book-desc" }
const _hoisted_7 = { class: "teaching-book-title title1" }
const _hoisted_8 = { class: "teaching-course-title title1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "teaching-course-img" }
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = { class: "teaching-course-desc" }
const _hoisted_13 = { class: "teaching-course-desc-title" }
const _hoisted_14 = { class: "teaching-course-desc-info" }
const _hoisted_15 = { class: "page-inner page-right" }
const _hoisted_16 = { class: "teaching-box-title title1" }
const _hoisted_17 = { class: "teaching-box" }
const _hoisted_18 = { class: "teaching-box-btn" }
const _hoisted_19 = { class: "teaching-box-inner1" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "teaching-box-inner1" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "teaching-box-inner3" }
const _hoisted_24 = { class: "teaching-box-inner3-top" }
const _hoisted_25 = { class: "activeColor" }
const _hoisted_26 = { class: "teaching-box-score" }
const _hoisted_27 = { class: "teaching-box-inner3-top-title3" }
const _hoisted_28 = { class: "activeColor" }
const _hoisted_29 = { class: "teaching-box-inner3-middle" }
const _hoisted_30 = { class: "xunlian-item" }
const _hoisted_31 = { class: "xunlian-item-middle" }
const _hoisted_32 = { class: "xunlian-item-middle-top" }
const _hoisted_33 = { class: "weight" }
const _hoisted_34 = { class: "weight" }
const _hoisted_35 = { class: "weight fc" }
const _hoisted_36 = { class: "xunlian-item-middle-bottom" }
const _hoisted_37 = { class: "weight" }
const _hoisted_38 = {
  key: 0,
  class: "xunlian-item-bottom"
}
const _hoisted_39 = { class: "xunlian-item right" }
const _hoisted_40 = { class: "xunlian-item-middle" }
const _hoisted_41 = { class: "xunlian-item-middle-top" }
const _hoisted_42 = { class: "weight" }
const _hoisted_43 = { class: "weight fb" }
const _hoisted_44 = { class: "weight" }
const _hoisted_45 = { class: "xunlian-item-middle-bottom" }
const _hoisted_46 = { class: "weight" }
const _hoisted_47 = {
  key: 0,
  class: "xunlian-item-bottom"
}
const _hoisted_48 = { class: "teaching-box-inner3-footer" }
const _hoisted_49 = { class: "question-top" }
const _hoisted_50 = { class: "question-top-left" }
const _hoisted_51 = { class: "activeColor" }
const _hoisted_52 = { class: "question-top-right" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "activeColor" }
const _hoisted_55 = { class: "problem-box" }
const _hoisted_56 = { class: "problem-box-title" }
const _hoisted_57 = { class: "problem-box-inner" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  class: "answer-box"
}
const _hoisted_60 = { class: "" }
const _hoisted_61 = { class: "" }
const _hoisted_62 = { class: "questionFooter" }
const _hoisted_63 = { class: "teaching-box-inner4" }
const _hoisted_64 = { class: "teachingBox3-inner" }
const _hoisted_65 = { class: "popup-inner" }
const _hoisted_66 = { class: "answer-popup" }
const _hoisted_67 = { class: "answer-box-inner" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "answer-popup-tip" }
const _hoisted_70 = {
  key: 0,
  class: "answer-popup-title"
}
const _hoisted_71 = {
  key: 1,
  class: "answer-popup-title"
}
const _hoisted_72 = { class: "dialog-footer" }

import clipBoard from "vue-clipboard3"
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { getBookList, getBookDetail, getBookAnalysis, getQuestionResult, getQuestionList, getQuestionAnswer, submitQuestion,getQuestionResultNew,getQuestionAnswerNew } from "@/api/composition.js"
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'teachingPage',
  setup(__props) {

let { toClipboard } = clipBoard()
const store = useStore();
const teachingActive = ref('1')
const resultInfo = ref({ comp_mod_analysis: '' })
const popupShow = ref(false)
const grade = ref(store.state.grade)
const term = ref(store.state.term)
const bookInfo = ref({})
const artiList = ref([])
const artiNum = ref(0)
const artiInfo = ref({})
const showPreview = ref(false)
const srcList = ref([])

onMounted(() => {
    getList(() => {
        toDetail(artiList.value[0].bookArityVoList[0])
    })
})

function previewEvent(url) {
    srcList.value = [url]
    showPreview.value = true
}

function getList(cb) {
    getBookList({
        grade: grade.value,
        term: term.value,
    }).then(res => {
        console.log(res)
        bookInfo.value = res.data.book || {};
        artiList.value = res.data.artiList || [];
        (res.data.artiList || []).forEach(item => {
            artiNum.value += item.bookArityVoList.length
        })
        cb && cb()
    })
}

function toDetail(item: any) {
    backEvent()
    teachingActive.value = '1';
    getDetail(item.artiId)
    getAnalysis(item.artiId)
    if (store.state.userInfo && store.state.userInfo.userId && sessionStorage.getItem('token')) {
        getResult(item.artiId)
        getResultNew(item.artiId)
    }
}
function getDetail(artiId: string) {
    getBookDetail(artiId).then((res: any) => {
        artiInfo.value = res.data;
        const artiText = res.data.artiText;
        artiInfo.value.artiNum = artiText.replace(/<[^>]*>/g, '').length || 0;
    })
}
function getAnalysis(artiId: string) {
    getBookAnalysis(artiId).then((res: any) => {
        resultInfo.value.comp_mod_analysis = res.data || ''
    })
}
// 训练秒评相关
const questionShow = ref(false)
const questionInfo = ref({
    questionOption: []
})
const questionNum = ref(0)
const isAnswer = ref(false)
const questionList = ref([])
const questionResult = ref({})
const questionResultNew =ref({})
const questionAnswer = ref({})
const nowAnswer = ref([])
const timeInfo = ref('00:00:00')
let timer = null
let startTime = ''
let questionCorrect = {}
watch(() => questionNum.value, () => {
    getQuestionInfo(() => {
        nowAnswer.value = questionInfo.value.questionId in questionAnswer.value ? questionAnswer.value[questionInfo.value.questionId] : []
    })
}, {
        immediate: true
    })
function getResult(artiId: string) {
    getQuestionResult(artiId).then((res: any) => {
        questionResult.value = res.data || {}
    })
}
function getResultNew(artiId: string) {
    getQuestionResultNew(artiId).then((res: any) => {
        questionResultNew.value = res.data || {}
    })
}

function correctFormat(rightNum,num){
    if(rightNum && num){
        return (rightNum/num*100).toFixed(2)
    }else{
        return 0
    }
}
function getAnswerClass(item) {
    let arr = ['problem-box-inner-item']
    if (isAnswer.value) {
        if (nowAnswer.value.includes(item.questionAnsswerId)) {
            console.log('++++')
            // 已选
            if (item.isCorrect == 1) { //正答
                arr.push('active-right')
            } else { //错答
                arr.push('active-error')
            }
        }
        // else{//未选
        // 	if(item.isCorrect==1){
        // 		arr.push('active-error')
        // 	}
        // }
    } else {
        if (nowAnswer.value.includes(item.questionAnsswerId)) {
            arr.push('active')
        }
    }
    return arr
}
function openTest(flag: number,type=0) {
    if (!store.state.userInfo || !store.state.userInfo.userId || !sessionStorage.getItem('token')) {
        return store.dispatch('setLoginFlag')
    }
    if (!questionResult.value.questionCount) {
        return ElMessage.warning('习题未发布，暂不能练习')
    }
    if (flag == 2) {
        isAnswer.value = true
    }
    getQuestion(() => {
        questionShow.value = true
        if (flag == 1) {
            let time = 0;
            startTime = getCurrentTime()
            timer = setInterval(() => {
                timeInfo.value = msToTime(time)
                time += 1000;
            }, 1000)
        }
    },type)
}
function msToTime(duration) {
    var seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
}
function getQuestion(cb: any,type=1) {
    getQuestionList(artiInfo.value.artiId).then((res: any) => {
        questionList.value = res.data || []
        let correct = {}
        questionList.value.forEach(item => {
            const questionOption = JSON.parse(item.questionOption)
            let arr = []
            questionOption.forEach(option => {
                if (option.isCorrect == 1) {
                    arr.push(option.questionAnsswerId)
                }
            })
            correct[item.questionId] = arr;
        })
        questionCorrect = correct;
        cb ? getQuestionInfo(cb) : getQuestionInfo()
        if (isAnswer.value) {
            getAnswer(cb,type)
        }
    })
}

function getQuestionInfo(cb) {
    let obj = {},
        val = questionNum.value;
    if (questionList.value.length) {
        obj = {
            ...questionList.value[val],
            questionOption: questionList.value[val].questionOption ? JSON.parse(questionList.value[val]
                .questionOption) : []
        }
    }
    questionInfo.value = obj;
    cb && cb()
}

function getAnswer(cb,type) {
    let api = type==2?getQuestionAnswer:getQuestionAnswerNew;
    api({ artiId: artiInfo.value.artiId }).then((res: any) => {
        let obj = {};
        (res.data || []).map((item: any) => {
            const answer = item.answer;
            obj[item.questionId] = answer ? answer.split(',').map(index => {
                return index
            }) : []
        })
        questionAnswer.value = obj;
        const questionId = questionList.value[questionNum.value].questionId
        nowAnswer.value = obj[questionId];
        cb && cb()
    })
}

function typeFormat(type: number) {
    switch (String(type)) {
        case '1':
            return '判断题';
        case '2':
            return '单选题';
        case '3':
            return '多选题';
        default:
            return type;
    }
}

function sortFormat(index: number) {
    return String.fromCharCode(64 + index)
}
function unitFormat(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];

    if (!num || isNaN(num)) {
        return "零";
    }

    var english = num.toString().split("");
    var result = "";

    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }

    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    result = result.replace(/零+/g, '零');
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    result = result.replace(/亿万/g, '亿');
    result = result.replace(/零+$/, '');
    result = result.replace(/^一十/g, '十');

    return result;
}
function submitEvent() {
    let valid = true,
        keys = Object.keys(questionAnswer.value);
    if (!keys.length) {
        valid = false;
    } else {
        valid = keys.some(item => {
            return questionAnswer.value[item].length
        })
    }
    if (!valid) {
        return ElMessage.warning('提交前至少答一题')
    }
    let answerArr = questionList.value.map(item => {
        if (item.questionId in questionAnswer.value) {
            return {
                questionId: item.questionId,
                answer: questionAnswer.value[item.questionId].join(',')
            }
        } else {
            return {
                questionId: item.questionId,
                answer: ''
            }
        }
    })
    const params = {
        "answerJsonArrayStr": JSON.stringify(answerArr),
        "artiId": artiInfo.value.artiId,
        "beginTime": startTime,
        "endTime": getCurrentTime()
    }
    submitQuestion(params).then(() => {
        ElMessage.success('提交成功')
        backEvent()
        getResult(artiInfo.value.artiId)
        getResultNew(artiInfo.value.artiId)
    })

}
const rightSort = computed(() => {
    const sort: any[] = []
    if (questionInfo.value.questionOption) {
        questionInfo.value.questionOption.forEach((item: any, index: number) => {
            if (item.isCorrect == 1) {
                sort.push(String.fromCharCode(64 + index + 1))
            }
        })
    }
    return sort.length ? sort.join('、') : ''
})
function answerActive(item: any) {
    return (item.questionId in questionAnswer.value && questionAnswer.value[item.questionId]
        .length) ? 'active' : ''
}
function answerCorrect(item: any) {
    if (isAnswer.value) {
        let correct: any[] = questionCorrect[item.questionId] || [], anwer = questionAnswer.value[item.questionId] || [], valid = true;
        if (!anwer.length) {
            return ''
        } else if (anwer.length != correct.length) {
            valid = false;
        } else {
            valid = correct.every(option => {
                return anwer.some(anwerItem => {
                    return anwerItem == option
                })
            })
        }
        return valid ? '' : 'warning'
    }
    return ''
}
function jumpEvent(index) {
    questionNum.value = index;
    popupShow.value = false;
}
function backEvent() {
    questionShow.value = false
    questionInfo.value = {
        questionOption: []
    }
    questionNum.value = 0
    isAnswer.value = false
    questionList.value = []
    questionAnswer.value = {}
    nowAnswer.value = []
    questionCorrect = {}
    if (timer) {
        timeInfo.value = '00:00:00'
        clearInterval(timer)
        timer = null
    }
}
function getCurrentTime() {
    const now = new Date(); // 获取当前时间
    const year = now.getFullYear(); // 获取年份
    const month = now.getMonth() + 1; // 获取月份，月份从0开始，所以要加1
    const day = now.getDate(); // 获取日
    const hours = now.getHours(); // 获取小时
    const minutes = now.getMinutes(); // 获取分钟
    const seconds = now.getSeconds(); // 获取秒

    // 格式化输出，保证月份和日期是两位数
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // 组合成完整的日期时间字符串
    return `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function questionClick(item) {
    if (isAnswer.value) return;
    let answer = []
    if (questionInfo.value.questionId in questionAnswer.value) {
        answer = questionAnswer.value[questionInfo.value.questionId];
        if (questionInfo.value.questionType == 3) {
            const answerIndex = answer.indexOf(item.questionAnsswerId)
            if (answerIndex > -1) {
                answer.splice(answerIndex, 1)
            } else {
                answer.push(item.questionAnsswerId)
            }
        } else {
            if (answer.length) {
                answer.splice(0, 1, item.questionAnsswerId)
            } else {
                answer.push(item.questionAnsswerId)
            }
        }
    } else {
        answer.push(item.questionAnsswerId)
    }
    nowAnswer.value = answer;
    questionAnswer.value[questionInfo.value.questionId] = answer
}

async function copyEvent() {
    try {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = artiInfo.value.artiText;
        const val = tempDiv.textContent || tempDiv.innerText || '';
        console.log(val)
        await toClipboard(val)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}
// 训练秒评相关

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: bookInfo.value.fileUrl,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (previewEvent(bookInfo.value.fileUrl)))
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(bookInfo.value.bookName), 1),
          _createElementVNode("div", null, "共" + _toDisplayString(artiNum.value) + "篇作文", 1)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artiList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "teaching-course",
          key: index
        }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(unitFormat(index+1)) + "、" + _toDisplayString(item.artiUnit), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.bookArityVoList, (unit) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "teaching-course-inner",
              key: unit.artiId,
              onClick: ($event: any) => (toDetail(unit))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: unit.artiImageFileUrl,
                  onClick: _withModifiers(($event: any) => (previewEvent(unit.artiImageFileUrl)), ["stop"])
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(unit.artiName), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(unit.artiIntroduction), 1)
              ])
            ], 8, _hoisted_9))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(artiInfo.value.artiName), 1),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_radio_group, {
            modelValue: teachingActive.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((teachingActive).value = $event)),
            fill: "#fae8d4",
            "text-color": "#ef8b25"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, {
                label: "范文展示",
                value: "1"
              }),
              _createVNode(_component_el_radio_button, {
                label: "范文讲解",
                value: "2"
              }),
              _createVNode(_component_el_radio_button, {
                label: "训练秒评",
                value: "3"
              }),
              _createVNode(_component_el_radio_button, {
                label: "三步九法思维",
                value: "4"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", {
          class: "teaching-box-inner1-text",
          innerHTML: artiInfo.value.artiText
        }, null, 8, _hoisted_20),
        _createElementVNode("div", {
          class: "teaching-box-inner1-btn",
          onClick: copyEvent
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Document)
            ]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createTextVNode(" 复制文本 "))
        ])
      ], 512), [
        [_vShow, teachingActive.value==1 && artiInfo.value.artiText]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: "teaching-box-inner1-text",
          innerHTML: resultInfo.value.comp_mod_analysis
        }, null, 8, _hoisted_22)
      ], 512), [
        [_vShow, teachingActive.value==2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(questionResult.value.maxLevel || ''), 1)
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "teaching-box-inner3-top-title2" }, "章节最高成绩", -1)),
            _createElementVNode("div", _hoisted_27, [
              _cache[12] || (_cache[12] = _createTextVNode("当前章节您已完成 ")),
              _createElementVNode("span", _hoisted_28, _toDisplayString(questionResult.value.testCount || 0), 1),
              _cache[13] || (_cache[13] = _createTextVNode("次答题训练"))
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "xunlian-item-top" }, [
                        _createElementVNode("div", { class: "weight" }, "最近一次答题记录"),
                        _createElementVNode("div", { class: "xunlian-item-top-btn" }, "本次成绩")
                      ], -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", null, "题目数量", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(questionResultNew.value.questionCount || 0), 1),
                              _cache[15] || (_cache[15] = _createTextVNode("道"))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", null, "正确数量", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(questionResultNew.value.maxCorrectNum || 0), 1),
                              _cache[17] || (_cache[17] = _createTextVNode("道"))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[20] || (_cache[20] = _createElementVNode("div", null, "正确率", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(correctFormat(questionResultNew.value.maxCorrectNum,questionResultNew.value.questionCount)), 1),
                              _cache[19] || (_cache[19] = _createTextVNode("%"))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", null, "答题耗时", -1)),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(questionResultNew.value.continueTime || '暂未考试'), 1)
                        ])
                      ]),
                      (questionResultNew.value.testCount && questionResultNew.value.testCount>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createVNode(_component_el_link, {
                              type: "warning",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (openTest(2,1)))
                            }, {
                              default: _withCtx(() => [
                                _cache[22] || (_cache[22] = _createTextVNode("查看详情")),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ArrowRightBold)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1,
                              __: [22]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "xunlian-item-top" }, [
                        _createElementVNode("div", { class: "weight" }, "历史最高记录"),
                        _createElementVNode("div", { class: "xunlian-item-top-btn" }, "最高成绩")
                      ], -1)),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", null, [
                            _cache[25] || (_cache[25] = _createElementVNode("div", null, "最高正确数量", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(questionResult.value.maxCorrectNum || 0), 1),
                              _cache[24] || (_cache[24] = _createTextVNode("道"))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("div", null, "最高正确率", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_43, _toDisplayString(correctFormat(questionResult.value.maxCorrectNum,questionResult.value.questionCount)), 1),
                              _cache[26] || (_cache[26] = _createTextVNode("%"))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[29] || (_cache[29] = _createElementVNode("div", null, "练习次数", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(questionResult.value.testCount || 0), 1),
                              _cache[28] || (_cache[28] = _createTextVNode("次"))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", null, "最高耗时", -1)),
                          _createElementVNode("div", _hoisted_46, _toDisplayString(questionResult.value.continueTime || '暂未考试'), 1)
                        ])
                      ]),
                      (questionResult.value.testCount && questionResult.value.testCount>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createVNode(_component_el_link, {
                              type: "primary",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (openTest(2,2)))
                            }, {
                              default: _withCtx(() => [
                                _cache[31] || (_cache[31] = _createTextVNode("查看详情")),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ArrowRightBold)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1,
                              __: [31]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "teaching-box-inner3-bottom" }, [
            _createElementVNode("div", { class: "teaching-box-inner3-bottom-rule" }, " 规则说明： "),
            _createElementVNode("div", { class: "teaching-box-inner3-bottom-text" }, [
              _createElementVNode("div", null, "1、您可以反复的答题练习，系统记录最高的一次成绩；"),
              _createElementVNode("div", null, "2、必须完成一次答题后才能查看答案解析；"),
              _createElementVNode("div", null, "3、你的科目导师可以查看到您全部；")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      color: "#ef8b25",
                      class: "footer-btn footer-btn1",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (openTest(1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!questionResult.value.testCount?'开始答题':'重新答题'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, !questionShow.value]
        ]),
        (questionShow.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_51, _toDisplayString(questionNum.value+1), 1),
                    _cache[34] || (_cache[34] = _createTextVNode("/ ")),
                    _createElementVNode("span", null, _toDisplayString(questionList.value.length), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(typeFormat(questionInfo.value.questionType)), 1)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  (!isAnswer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createVNode(_component_el_icon, { color: "#ef8b25" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Coin)
                          ]),
                          _: 1
                        }),
                        _cache[35] || (_cache[35] = _createElementVNode("span", null, "计时：", -1)),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(timeInfo.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (popupShow.value=true))
                  }, [
                    _createVNode(_component_el_icon, { color: "#ef8b25" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Calendar)
                      ]),
                      _: 1
                    }),
                    _cache[36] || (_cache[36] = _createTextVNode("题卡"))
                  ]),
                  _createElementVNode("div", { onClick: backEvent }, [
                    _createVNode(_component_el_icon, { color: "#ef8b25" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DArrowLeft)
                      ]),
                      _: 1
                    }),
                    _cache[37] || (_cache[37] = _createTextVNode("返回上级"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, _toDisplayString(questionNum.value+1) + "、" + _toDisplayString(questionInfo.value.questionName), 1),
                _createElementVNode("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionInfo.value.questionOption, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(getAnswerClass(item)),
                      key: index,
                      onClick: ($event: any) => (questionClick(item))
                    }, _toDisplayString(sortFormat(index+1)) + "、" + _toDisplayString(item.content), 11, _hoisted_58))
                  }), 128))
                ])
              ]),
              (isAnswer.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "activeColor" }, "正确答案：", -1)),
                      _createTextVNode(" " + _toDisplayString(rightSort.value), 1)
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "activeColor" }, " 解析： ", -1)),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(questionInfo.value.questionTranslation), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_el_button, {
                  color: "#ef8b25",
                  plain: "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (questionNum.value--)),
                  disabled: questionNum.value===0
                }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("上一题")
                  ])),
                  _: 1,
                  __: [40]
                }, 8, ["disabled"]),
                (!isAnswer.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      color: "#ef8b25",
                      class: "footer-btn1",
                      onClick: submitEvent
                    }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode("提交答案")
                      ])),
                      _: 1,
                      __: [41]
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  color: "#ef8b25",
                  plain: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (questionNum.value++)),
                  disabled: questionNum.value===questionList.value.length-1
                }, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createTextVNode("下一题")
                  ])),
                  _: 1,
                  __: [42]
                }, 8, ["disabled"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, teachingActive.value==3]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_63, [
        _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"teachingBox3-top\" data-v-10233612><div class=\"teachingBox3-left\" data-v-10233612> 什么是三步九法？ </div><div class=\"teachingBox3-right\" data-v-10233612><span class=\"teachingBox3-title\" data-v-10233612>开悟作文核心思想展示</span></div></div><img class=\"teachingBox3-img\" src=\"" + _imports_0 + "\" data-v-10233612>", 2)),
        _createElementVNode("div", _hoisted_64, [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => _cache[43] || (_cache[43] = [
              _createElementVNode("span", { style: {"color":"#333","font-size":"16px"} }, "九法详解", -1)
            ])),
            _: 1,
            __: [43]
          }),
          _cache[44] || (_cache[44] = _createStaticVNode("<div class=\"teachingInner\" data-v-10233612><div class=\"teachingInnerTitle\" data-v-10233612>一、多头放想</div><div class=\"teachingInnersTitle\" data-v-10233612> 从“上头”“下头”“后头”(家国情怀)、(身边事)“前头”(经历)、(憧憬)多角度搜索素材 </div><div class=\"teachingInnerTitle\" data-v-10233612>二、多向放想</div><div class=\"teachingInnersTitle\" data-v-10233612> 横向(同类扩展)、纵向(因果逻辑)、侧向(关联领域)反向(逆向思维)全方位扫描信息 </div><div class=\"teachingInnerTitle\" data-v-10233612>三、多见放想</div><div class=\"teachingInnersTitle\" data-v-10233612> 整合阅读积累、观察所得、人际交往中的“存量信息” </div><div class=\"teachingInnerTitle\" data-v-10233612>四、触发悟道</div><div class=\"teachingInnersTitle\" data-v-10233612> 通过关键词碰撞激发灵感(如思维导图、关联词联想) </div><div class=\"teachingInnerTitle\" data-v-10233612>五、推导悟道</div><div class=\"teachingInnersTitle\" data-v-10233612> 分析事物内在联系(如大与小、现象与本质)提炼规律性人知 </div><div class=\"teachingInnerTitle\" data-v-10233612>六、升维悟道</div><div class=\"teachingInnersTitle\" data-v-10233612> 通过背景铺垫、联系实际、系统聚焦，提升观点维度 </div><div class=\"teachingInnerTitle\" data-v-10233612>七、守正悟道</div><div class=\"teachingInnersTitle\" data-v-10233612> 坚守立意正确性(立德、真实、得体)，确保方向不偏 </div><div class=\"teachingInnerTitle\" data-v-10233612>八、打包</div><div class=\"teachingInnersTitle\" data-v-10233612> 将素材或句式(排比、比喻等)按逻辑打包为“套包”，增强系统张力 </div><div class=\"teachingInnerTitle\" data-v-10233612>九、整合</div><div class=\"teachingInnersTitle\" data-v-10233612> 依框架模型组装(如“三块辖N段”:导语 分述 结语:“一线串N包””:主题线串联套包)，形成完整行文路线 </div></div>", 1))
        ])
      ], 512), [
        [_vShow, teachingActive.value==4]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: popupShow.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((popupShow).value = $event)),
      title: "题卡",
      width: "500px",
      center: ""
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (jumpEvent(index)),
                  class: _normalizeClass(['answer-box-inner-item',answerActive(item),answerCorrect(item)])
                }, _toDisplayString(index+1), 11, _hoisted_68))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            (!isAnswer.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, " 绿色为已作答题目，可点击题号快速跳转到对应题目 "))
              : _createCommentVNode("", true),
            (isAnswer.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, " 绿色为已答对题目，红色为答错题目，白色为未答题目，可点击题号 快速跳转到对应题目 "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 2
    }, [
      (!isAnswer.value)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_el_button, {
                  color: "#ef8b25",
                  class: "footer-btn1",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = false))
                }, {
                  default: _withCtx(() => _cache[46] || (_cache[46] = [
                    _createTextVNode("提交答案")
                  ])),
                  _: 1,
                  __: [46]
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"]),
    (showPreview.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": srcList.value,
          "show-progress": "",
          onClose: _cache[10] || (_cache[10] = ($event: any) => (showPreview.value = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})